<template>
  <div id="login-index" class="fullscreen-bg">
    <div class="login-container">
      <div class="brand-section">
        <div class="brand-content">
          <img :src="require('@/assets/img/logo.png')" class="brand-logo" />
          <div class="brand-info">
            <h1 class="brand-name">HERON6000</h1>
            <div class="version-info">{{ version }}</div>
            
          </div>
        </div>
      </div>

      <!-- 右侧登录表单区域 -->
      <div class="login-section">
        <div class="login-form">
          <div class="login-lang"><LangSelect></LangSelect></div>
          <h2 class="form-title">{{ getTranslation('c021') }}</h2>
          <div class="form-group">
            <div class="input-wrapper">
              <Icon type="ios-person" class="input-icon" />
              <Input v-model="username" :placeholder="getTranslation('c004')" class="custom-input" size="large" />
            </div>
          </div>
          <div class="form-group">
            <div class="input-wrapper">
              <Icon type="md-lock" class="input-icon" />
              <Input type="password" v-model="password" password :placeholder="getTranslation('c005')" class="custom-input"
                size="large" @on-enter="login" />

            </div>
            
          </div>
          <Button type="primary" @click="login()" class="login-btn" size="large" long>
            {{ getTranslation('c003') }}
          </Button>
          <div class="doc-line"><router-link to="/doc" class="doc-info">{{ getTranslation('m215') }}</router-link></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
import LangSelect from '@/components/LangSelect.vue'
export default {
  name: 'LoginIndex',
  computed: {
    ...mapGetters(['getTranslation'])
  },
  data() {
    return {
      // 响应式数据
      lang: {
        "userLogin": "",
        "emptyUser": "",
      },
      username: '',
      password: '',
      version: '',
    }
  },
  components: {
    LangSelect
  },
  created() {
    this.checkLogined()
    this.getVersion();
  },
  methods: {
    validateForm() {
      let errorMsg = '';
      let isValid = true;
      if (!this.username) {
        errorMsg = this.getTranslation('c004');
        isValid = false;
      } else if (!this.password) {
        errorMsg = this.getTranslation('c005');
        isValid = false;
      }
      if (errorMsg) {
        this.$Message.error(errorMsg);
      }
      return isValid;
    },
    login() {
      if (!this.validateForm()) return;
      let url = API_URL["userLogin"];
      axios.post(url, {
        'username': this.username,
        'password': this.password
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$router.push('/dashboard')
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    checkLogined() {
      let url = API_URL["userLogined"];
      axios.get(url)
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$router.push('/dashboard')
          }else if(res && res.data && res.data.code ==3002){
            this.$Modal.error({
              title: "",
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation('b181'),
              onOk: () => {
              
              }
            })
          }
        })
        .catch((err) => {
          postJsError(err)
        })
    },
    getVersion() {
      let url = API_URL["systemVersion"];
      axios.get(url)
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.version = res.data.data.version
          }
        })
        .catch((err) => {
          postJsError(err)
        })
    }
  }
}
</script>

<style scoped>
@import url('../../assets/style/list.css');

.fullscreen-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

.login-container {
  display: flex;
  width: 800px;
  height: 400px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* 左侧品牌区域 */
.brand-section {
  flex: 1;
  background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.brand-content {
  text-align: center;
}

.brand-logo {
  width: 150px;
  height: auto;
  margin-bottom: 30px;
  object-fit: contain;
}

.brand-name {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 10px;
  letter-spacing: 2px;
}

.version-info {
  font-size: 16px;
  opacity: 0.8;
  margin-bottom: 20px;
  font-weight: 500;
}
.doc-line{
  margin-top: 4px;
 text-align: right;
}
.doc-info{
  font-size: 16px;  
  margin-bottom: 20px;
  font-weight: 500;
  color: #2db7f5;
  
}
.doc-info:hover{
  color: #bdc3c7;
  transform: translateY(-2px);
}


.brand-tagline {
  font-size: 14px;
  opacity: 0.7;
  line-height: 1.6;
}

/* 右侧登录区域 */
.login-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 40px 40px 40px;
}

.login-form {
  width: 100%;
  max-width: 320px;
}

.form-title {
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 40px;
  text-align: center;
}

.form-group {
  margin-bottom: 24px;
}

.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #7f8c8d;
  z-index: 2;
  font-size: 18px;
}

.custom-input {
  width: 100%;
  padding-left: 48px !important;
  height: 48px;
  border: 2px solid #ecf0f1;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.custom-input:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.login-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  border: none;
  transition: all 0.3s ease;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(52, 152, 219, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
    width: 90%;
    height: auto;
  }

  .brand-section {
    padding: 30px 20px;
  }

  .login-section {
    padding: 30px 20px;
  }
}
.login-lang{
  display:block;
  text-align:right;
  margin-bottom:10px;
}
</style>
